import { clstx } from '@payaca/utilities/cvaMerge';
import { forwardRef } from 'react';

import Card, { CardProps } from './Card';

const CardButton = forwardRef<HTMLButtonElement, CardProps<'button'>>(
  (props, ref) => {
    const { className, children, type = 'button', ...rest } = props;

    return (
      <Card
        as="button"
        ref={ref}
        className={clstx(
          'block w-full p-0 text-left hover:cursor-pointer enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:opacity-50',
          className
        )}
        type={type}
        {...rest}
      >
        {children}
      </Card>
    );
  }
);

export default Object.assign(CardButton, {
  // todo: refactor this out, just use Card.Body separately
  Body: Card.Body,
});
